import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY, PART_PRICING_LOG, DEPENDENT_TABLES_ALL as depTableNames } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	localState:{},
	depTableNames,
	dropdownList: {
		DphSzbOzn: [],
		Nahrada: [],
		OdhcenaPzn: [],
		VyrobekndOzn: [],
		VybehPzn: [],
	},
	edit: {
		BalicJdn: null as number | null,
		CenaGd: null as number | null,
		CenaGdMod: null as number | null,
		DphSzbOzn: null as number | null,
		EconomyPrp: null as boolean | null,
		ForcedUpdatePrp: null as number | null,
		MarketKod: null as string | null,
		GstGroupCode: null as string | null,
		NahradaPzn: null as number | null,
		NdNr: null as string | null,
		OdhcenaPzn: null as number | null,
		PcAp: null as number | null,
		PcGar: null as number | null,
		PcGd: null as number | null,
		PcGdRyo: null as number | null,
		PcGdSko: null as number | null,
		PcGdVcetneDph: null as number | null,
		PseudoNdPrp: null as boolean | null,
		Poznamka: null as string | null,
		RabatSk: null as string | null,
		RabatSkText: null as string | null,
		ShodnyndPzn: null as number | null,
		Text: null as string | null,
		VstupDat: null as string | null,
		VybehPzn: null as number | null,
		VyrobekndOzn: null as string | null,
		ZaznamId: null as number | null,
		ZbozidruhOzn: null as string | null,
		ZbozidruhOznText: null as string | null,
		StavSklad: null as string | null,
		PocetDotaz: null as number | null,
		PocetSpc: null as number | null,
		SkladOzn: null as number | null,
		GSTPercentage: 0 as number,
		HsnCode: null as number | null,
		LocalRrp: null as number | null,
	},
	depTableSettings: {
		[PART_PRICING_LOG]: {
			loadByEntityId: true,
			filter(state) {
				return {
					Brand: state.edit.VyrobekndOzn,
					NdNr: state.edit.NdNr,
					WareHouse: state.edit.SkladOzn
				};
			},
		},
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.ND_CENIK_RABAT_SK_SELECT_MAPPER](state, { data }) {
			state.edit.RabatSk = data.value;
			state.edit.RabatSkText = data.text;
		},
		[types.mutations.ND_CENIK_ZBOZI_DRUH_SELECT_MAPPER](state, { data }) {
			state.edit.ZbozidruhOzn = data.value;
			state.edit.ZbozidruhOznText = data.text;
		},
	},
	props: {
		mode: null,
	},
});
